export default "__VITE_ASSET__DAR$zh_0__"